import { useLocation } from '@tanstack/react-router';
import {
  GitPullRequestArrow,
  Layers3,
  Link,
  type LucideIcon,
  NotebookTabsIcon,
  Search,
  Settings,
  User,
} from 'lucide-react';
import { useIntl } from 'react-intl';

import type { FileRouteTypes } from '@/routeTree.gen';

import { useFeatureFlags } from '../providers/FeatureFlagsProvider';

type Group = {
  menus: {
    to: FileRouteTypes['to'];
    label: string;
    active: boolean;
    icon: LucideIcon;
  }[];
};

export function useMenuList(): Group[] {
  const { pathname } = useLocation();
  const { formatMessage } = useIntl();

  const featureFlags = useFeatureFlags();

  const menuList: Group[] = [
    {
      menus: [
        ...(featureFlags.FeatureAskAnnie === true
          ? [
              {
                to: '/catalog' as const,
                label: formatMessage({ id: 'global.menu.catalog' }),
                active: pathname.includes('/catalog'),
                icon: NotebookTabsIcon,
              },
            ]
          : []),
        ...(featureFlags.FeatureSearchCoverage === true
          ? [
              {
                to: '/' as const,
                label: formatMessage({ id: 'global.menu.search' }),
                active: pathname === '/',
                icon: Search,
              },
              {
                to: '/coverage' as const,
                label: formatMessage({ id: 'global.menu.coverage' }),
                active: pathname.includes('/coverage'),
                icon: Layers3,
              },
            ]
          : []),
        ...(featureFlags.FeaturePRList === true
          ? [
              {
                to: '/pull-request' as const,
                label: formatMessage({ id: 'global.menu.pullRequest' }),
                active: pathname.includes('/pull-request'),
                icon: GitPullRequestArrow,
              },
            ]
          : []),
      ],
    },
    {
      menus: [
        {
          to: '/integrations',
          label: formatMessage({ id: 'global.menu.integrations' }),
          active: pathname.includes('/integrations'),
          icon: Link,
        },
        {
          to: '/configuration',
          label: formatMessage({ id: 'global.menu.configuration' }),
          active: pathname.includes('/configuration'),
          icon: Settings,
        },
        {
          to: '/my-profile',
          label: formatMessage({ id: 'global.menu.myProfile' }),
          active: pathname.includes('/my-profile'),
          icon: User,
        },
      ],
    },
  ];

  return menuList.filter(group => group.menus.length > 0);
}
